// Import main category images
import birthdayMainImg from '../assets/images/Category/Birthday/Gemini_Generated_Image_mxpymjmxpymjmxpy.webp';
import kidesSetupMainImg from '../assets/images/Category/Kides Setup/Gemini_Generated_Image_9hn9pf9hn9pf9hn9.webp';
import annaprashanMainImg from '../assets/images/Category/AnnaPrasan/Gemini_Generated_Image_rb9z83rb9z83rb9z.webp';
import babyWelcomeMainImg from '../assets/images/Category/Baby Welcome/Gemini_Generated_Image_gtjmb8gtjmb8gtjm.webp';
import loveThemeMainImg from '../assets/images/Category/LoveTheme/Gemini_Generated_Image_k85k2jk85k2jk85k.webp';
import anniversarySetupMainImg from '../assets/images/Category/Anniversary/Gemini_Generated_Image_6yh8uv6yh8uv6yh8.webp';
import justMarriedMainImg from '../assets/images/Category/JustMarried/Gemini_Generated_Image_ykjwmvykjwmvykjw.webp';
import canopySetupMainImg from '../assets/images/Category/CanopySetup/Gemini_Generated_Image_biiqa5biiqa5biiq.webp';
import babyShowerMainImg from '../assets/images/Category/BabyShower/Gemini_Generated_Image_swq3oxswq3oxswq3.webp';
import ringSetupMainImg from '../assets/images/Category/RingSetup/Gemini_Generated_Image_lxabirlxabirlxab.webp';
import bachelorPartyMainImg from '../assets/images/Category/BachlorParty/Gemini_Generated_Image_rdxu9mrdxu9mrdxu.webp';
import marqueeMainImg from '../assets/images/Category/Marquee/Gemini_Generated_Image_1k5ck1k5ck1k5ck1.webp';
import carBootMainImg from '../assets/images/Category/CarBoot/Gemini_Generated_Image_crsaqmcrsaqmcrsa.webp';
import garlendSetupMainImg from '../assets/images/Category/GarlendSetup/Gemini_Generated_Image_5ecdg95ecdg95ecd.webp';
import gamesActivitiesMainImg from '../assets/images/Category/Games And Activies/Gemini_Generated_Image_cd6i8acd6i8acd6i.webp';
import haldiMainImg from '../assets/images/Category/Haldi /Gemini_Generated_Image_g8nsxg8nsxg8nsxg.webp';
import jungleThemeMainImg from '../assets/images/Category/jungle theme /Gemini_Generated_Image_5vfejy5vfejy5vfe.png';
import brideWelcomeMainImg from '../assets/images/Category/BrideWelcome/Gemini_Generated_Image_32qcyx32qcyx32qc (1).webp';

// Import NextPageImages for Birthday
import birthdayNextImg1 from '../assets/images/Category/Birthday/NextPageImages/Gemini_Generated_Image_3l2tnw3l2tnw3l2t.webp';
import birthdayNextImg2 from '../assets/images/Category/Birthday/NextPageImages/Gemini_Generated_Image_46zmvn46zmvn46zm.webp';
import birthdayNextImg3 from '../assets/images/Category/Birthday/NextPageImages/Gemini_Generated_Image_e2fglae2fglae2fg.webp';
import birthdayNextImg4 from '../assets/images/Category/Birthday/NextPageImages/Gemini_Generated_Image_txuigctxuigctxui.webp';
import birthdayNextImg5 from '../assets/images/Category/Birthday/NextPageImages/Gemini_Generated_Image_ugox66ugox66ugox (1).webp';

// Import NextPageImage for Kides Setup
import kidesSetupNextImg1 from '../assets/images/Category/Kides Setup/NextPageImage/Gemini_Generated_Image_4bo2qp4bo2qp4bo2 (2).webp';
import kidesSetupNextImg2 from '../assets/images/Category/Kides Setup/NextPageImage/Gemini_Generated_Image_dk2f0ndk2f0ndk2f.webp';
import kidesSetupNextImg3 from '../assets/images/Category/Kides Setup/NextPageImage/Gemini_Generated_Image_e2fglae2fglae2fg.webp';
import kidesSetupNextImg4 from '../assets/images/Category/Kides Setup/NextPageImage/Gemini_Generated_Image_f7ts3lf7ts3lf7ts.webp';
import kidesSetupNextImg5 from '../assets/images/Category/Kides Setup/NextPageImage/Gemini_Generated_Image_wfu5cdwfu5cdwfu5.webp';

// Import NextPageImage for Annaprashan
import annaprashanNextImg1 from '../assets/images/Category/AnnaPrasan/NextPageImage/freepik__35mm-film-photography-a-modern-baby-celebration-dc__31358.webp';
import annaprashanNextImg2 from '../assets/images/Category/AnnaPrasan/NextPageImage/freepik__35mm-film-photography-dreamy-celebration-vibe-warm__31362.webp';
import annaprashanNextImg3 from '../assets/images/Category/AnnaPrasan/NextPageImage/freepik__35mm-film-photography-minimalist-scandinavian-nurs__31357.webp';
import annaprashanNextImg4 from '../assets/images/Category/AnnaPrasan/NextPageImage/freepik__35mm-film-photography-pastel-aesthetic-newborn-wel__31360 (1).webp';

// Import NextPageImage for Baby Welcome
import babyWelcomeNextImg1 from '../assets/images/Category/Baby Welcome/NextPageImage/freepik__35mm-film-photography-a-soft-blush-pink-and-ivory-__89617 (1).webp';
import babyWelcomeNextImg2 from '../assets/images/Category/Baby Welcome/NextPageImage/freepik__35mm-film-photography-a-soft-blush-pink-and-ivory-__89618.webp';
import babyWelcomeNextImg3 from '../assets/images/Category/Baby Welcome/NextPageImage/freepik__35mm-film-photography-genderneutral-baby-welcome-s__89619.webp';
import babyWelcomeNextImg4 from '../assets/images/Category/Baby Welcome/NextPageImage/freepik__35mm-film-photography-halfarch-of-blue-silver-whit__89620.webp';
import babyWelcomeNextImg5 from '../assets/images/Category/Baby Welcome/NextPageImage/Gemini_Generated_Image_1rssry1rssry1rss.webp';

// Import NextPageImage for Love Theme
import loveThemeNextImg1 from '../assets/images/Category/LoveTheme/NextPageImage/freepik__35mm-film-photography-a-romantic-lovethemed-decora__89621.webp';
import loveThemeNextImg2 from '../assets/images/Category/LoveTheme/NextPageImage/freepik__35mm-film-photography-cozy-nighttime-romantic-setu__20938.webp';
import loveThemeNextImg3 from '../assets/images/Category/LoveTheme/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__89623.webp';
import loveThemeNextImg4 from '../assets/images/Category/LoveTheme/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__89624 (1).webp';

// Import NextPageImage for Anniversary Setup
import anniversaryNextImg1 from '../assets/images/Category/Anniversary/NextPageImage/freepik__35mm-film-photography-cozy-romantic-bedroom-scene-__20940.webp';
import anniversaryNextImg2 from '../assets/images/Category/Anniversary/NextPageImage/freepik__35mm-film-photography-elegant-anniversary-bedroom-__20941.webp';
import anniversaryNextImg3 from '../assets/images/Category/Anniversary/NextPageImage/freepik__35mm-film-photography-romantic-bedroom-anniversary__20942.webp';
import anniversaryNextImg4 from '../assets/images/Category/Anniversary/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__20939.webp';

// Import NextPageImage for Just Married
import justMarriedNextImg1 from '../assets/images/Category/JustMarried/NextPageImage/freepik__35mm-film-photography-opulent-suite-king-bed-strew__5698.webp';
import justMarriedNextImg2 from '../assets/images/Category/JustMarried/NextPageImage/freepik__35mm-film-photography-romantic-wedding-night-hotel__5700.webp';
import justMarriedNextImg3 from '../assets/images/Category/JustMarried/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__5699.webp';
import justMarriedNextImg4 from '../assets/images/Category/JustMarried/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__5701.webp';

// Import NextPageImage for Canopy Setup
import canopySetupNextImg1 from '../assets/images/Category/CanopySetup/NextPageImage/freepik__35mm-film-photography-canopy-bed-with-flowing-whit__14545.webp';
import canopySetupNextImg2 from '../assets/images/Category/CanopySetup/NextPageImage/freepik__35mm-film-photography-luxury-anniversary-canopy-wi__20956.webp';
import canopySetupNextImg3 from '../assets/images/Category/CanopySetup/NextPageImage/freepik__35mm-film-photography-romantic-canopy-bed-with-tri__14544.webp';
import canopySetupNextImg4 from '../assets/images/Category/CanopySetup/NextPageImage/freepik__35mm-film-photography-sheer-white-tentlike-canopy-__20955.webp';

// Import NextPageImage for Baby Shower
import babyShowerNextImg1 from '../assets/images/Category/BabyShower/NextPageImage/freepik__35mm-film-photography-a-joyful-baby-shower-and-gen__20944.webp';
import babyShowerNextImg2 from '../assets/images/Category/BabyShower/NextPageImage/freepik__35mm-film-photography-happy-baby-celebration-with-__20946.webp';
import babyShowerNextImg3 from '../assets/images/Category/BabyShower/NextPageImage/freepik__35mm-film-photography-premium-baby-celebration-dco__20945 (8).webp';
import babyShowerNextImg4 from '../assets/images/Category/BabyShower/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__20943.webp';

// Import NextPageImage for Ring Setup
import ringSetupNextImg1 from '../assets/images/Category/RingSetup/NextPageImage/freepik__35mm-film-photography-a-luxury-romantic-ring-propo__5702.webp';
import ringSetupNextImg2 from '../assets/images/Category/RingSetup/NextPageImage/freepik__35mm-film-photography-diamond-engagement-ring-on-v__5705.webp';
import ringSetupNextImg3 from '../assets/images/Category/RingSetup/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__5703.webp';
import ringSetupNextImg4 from '../assets/images/Category/RingSetup/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__5704.webp';

// Import NextPageImage for Bachelor Party
import bachelorPartyNextImg1 from '../assets/images/Category/BachlorParty/NextPageImage/freepik__35mm-film-photography-a-minimal-luxury-bachelor-pa__20950.webp';
import bachelorPartyNextImg2 from '../assets/images/Category/BachlorParty/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__20947.webp';
import bachelorPartyNextImg3 from '../assets/images/Category/BachlorParty/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__20948.webp';
import bachelorPartyNextImg4 from '../assets/images/Category/BachlorParty/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__20949.webp';

// Import NextPageImage for Marquee
import marqueeNextImg1 from '../assets/images/Category/Marquee/NextPageImage/freepik__35mm-film-photography-clean-wall-backdrop-marquee-__5709.webp';
import marqueeNextImg2 from '../assets/images/Category/Marquee/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__5706.webp';
import marqueeNextImg3 from '../assets/images/Category/Marquee/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__5707.webp';
import marqueeNextImg4 from '../assets/images/Category/Marquee/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__5708.webp';

// Import NextPageImage for Car Boot
import carBootNextImg1 from '../assets/images/Category/CarBoot/NextPageImage/freepik__35mm-film-photography-a-romantic-car-boot-proposal__14547.webp';
import carBootNextImg2 from '../assets/images/Category/CarBoot/NextPageImage/freepik__35mm-film-photography-car-boot-decorated-for-a-bir__14546.webp';
import carBootNextImg3 from '../assets/images/Category/CarBoot/NextPageImage/freepik__35mm-film-photography-open-car-boot-with-pastel-bl__14548.webp';
import carBootNextImg4 from '../assets/images/Category/CarBoot/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__14549.webp';

// Import NextPageImage for Garlend Setup
import garlendSetupNextImg1 from '../assets/images/Category/GarlendSetup/NextPageImage/freepik__35mm-film-photography-a-rich-maroon-gold-and-bronz__14557.webp';
import garlendSetupNextImg2 from '../assets/images/Category/GarlendSetup/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__14554.webp';
import garlendSetupNextImg3 from '../assets/images/Category/GarlendSetup/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__14555.webp';
import garlendSetupNextImg4 from '../assets/images/Category/GarlendSetup/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__14556.webp';

// Import NextPageImage for Games & Activities
import gamesActivitiesNextImg1 from '../assets/images/Category/Games And Activies/NextPageImage/freepik__35mm-film-photography-a-birthday-party-games-stage__14552 (1).webp';
import gamesActivitiesNextImg2 from '../assets/images/Category/Games And Activies/NextPageImage/freepik__35mm-film-photography-kids-and-adults-enjoying-int__14551.webp';
import gamesActivitiesNextImg3 from '../assets/images/Category/Games And Activies/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__14550.webp';
import gamesActivitiesNextImg4 from '../assets/images/Category/Games And Activies/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__14553.webp';

// Import NextPageImage for Haldi
import haldiNextImg1 from '../assets/images/Category/Haldi /NextPageImage/freepik__35mm-film-photography-indoor-haldi-arrangement-wit__14560.webp';
import haldiNextImg2 from '../assets/images/Category/Haldi /NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__14558.webp';
import haldiNextImg3 from '../assets/images/Category/Haldi /NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__14559.webp';
import haldiNextImg4 from '../assets/images/Category/Haldi /NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__14562.webp';

// Import NextPageImage for Jungle Theme
import jungleThemeNextImg1 from '../assets/images/Category/jungle theme /NextPageImage/freepik__35mm-film-photography-cute-safari-animal-illustrat__14563.webp';
import jungleThemeNextImg2 from '../assets/images/Category/jungle theme /NextPageImage/freepik__35mm-film-photography-modern-indoor-luxury-jungle-__5695.webp';
import jungleThemeNextImg3 from '../assets/images/Category/jungle theme /NextPageImage/freepik__a-pastel-junglethemed-baby-celebration-setup-with-__5697.webp';
import jungleThemeNextImg4 from '../assets/images/Category/jungle theme /NextPageImage/freepik__fun-cartoonstyle-tropical-backdrop-with-palm-leave__5696.webp';

// Import NextPageImage for Bride Welcome
import brideWelcomeNextImg1 from '../assets/images/Category/BrideWelcome/NextPageImage/freepik__35mm-film-photography-a-minimal-bride-welcome-deco__20951.webp';
import brideWelcomeNextImg2 from '../assets/images/Category/BrideWelcome/NextPageImage/freepik__35mm-film-photography-indoor-wedding-welcome-displ__20953.webp';
import brideWelcomeNextImg3 from '../assets/images/Category/BrideWelcome/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__20952.webp';
import brideWelcomeNextImg4 from '../assets/images/Category/BrideWelcome/NextPageImage/freepik__the-style-is-candid-image-photography-with-natural__20954.webp';

// Category Images Data Structure
export const categoryImagesData = [
  {
    id: 1,
    name: 'Birthday Setup',
    slug: 'birthday-setup',
    mainImage: birthdayMainImg,
    nextPageImages: [
      birthdayNextImg1,
      birthdayNextImg2,
      birthdayNextImg3,
      birthdayNextImg4,
      birthdayNextImg5,
    ],
  },
  {
    id: 2,
    name: 'Kides Setup',
    slug: 'kides-setup',
    mainImage: kidesSetupMainImg,
    nextPageImages: [
      kidesSetupNextImg1,
      kidesSetupNextImg2,
      kidesSetupNextImg3,
      kidesSetupNextImg4,
      kidesSetupNextImg5,
    ],
  },
  {
    id: 3,
    name: 'Annaprashan',
    slug: 'annaprashan',
    mainImage: annaprashanMainImg,
    nextPageImages: [
      annaprashanNextImg1,
      annaprashanNextImg2,
      annaprashanNextImg3,
      annaprashanNextImg4,
    ],
  },
  {
    id: 4,
    name: 'Baby Welcome',
    slug: 'baby-welcome',
    mainImage: babyWelcomeMainImg,
    nextPageImages: [
      babyWelcomeNextImg1,
      babyWelcomeNextImg2,
      babyWelcomeNextImg3,
      babyWelcomeNextImg4,
      babyWelcomeNextImg5,
    ],
  },
  {
    id: 5,
    name: 'Love theme',
    slug: 'love-theme',
    mainImage: loveThemeMainImg,
    nextPageImages: [
      loveThemeNextImg1,
      loveThemeNextImg2,
      loveThemeNextImg3,
      loveThemeNextImg4,
    ],
  },
  {
    id: 6,
    name: 'Anniversary Setup',
    slug: 'anniversary-setup',
    mainImage: anniversarySetupMainImg,
    nextPageImages: [
      anniversaryNextImg1,
      anniversaryNextImg2,
      anniversaryNextImg3,
      anniversaryNextImg4,
    ],
  },
  {
    id: 7,
    name: 'Just Married',
    slug: 'just-married',
    mainImage: justMarriedMainImg,
    nextPageImages: [
      justMarriedNextImg1,
      justMarriedNextImg2,
      justMarriedNextImg3,
      justMarriedNextImg4,
    ],
  },
  {
    id: 8,
    name: 'Canopy Setup',
    slug: 'canopy-setup',
    mainImage: canopySetupMainImg,
    nextPageImages: [
      canopySetupNextImg1,
      canopySetupNextImg2,
      canopySetupNextImg3,
      canopySetupNextImg4,
    ],
  },
  {
    id: 9,
    name: 'Baby Shower',
    slug: 'baby-shower',
    mainImage: babyShowerMainImg,
    nextPageImages: [
      babyShowerNextImg1,
      babyShowerNextImg2,
      babyShowerNextImg3,
      babyShowerNextImg4,
    ],
  },
  {
    id: 10,
    name: 'Ring Setup',
    slug: 'ring-setup',
    mainImage: ringSetupMainImg,
    nextPageImages: [
      ringSetupNextImg1,
      ringSetupNextImg2,
      ringSetupNextImg3,
      ringSetupNextImg4,
    ],
  },
  {
    id: 11,
    name: 'Bachelor Party',
    slug: 'bachelor-party',
    mainImage: bachelorPartyMainImg,
    nextPageImages: [
      bachelorPartyNextImg1,
      bachelorPartyNextImg2,
      bachelorPartyNextImg3,
      bachelorPartyNextImg4,
    ],
  },
  {
    id: 12,
    name: 'Marquee',
    slug: 'marquee',
    mainImage: marqueeMainImg,
    nextPageImages: [
      marqueeNextImg1,
      marqueeNextImg2,
      marqueeNextImg3,
      marqueeNextImg4,
    ],
  },
  {
    id: 13,
    name: 'Car Boot',
    slug: 'car-boot',
    mainImage: carBootMainImg,
    nextPageImages: [
      carBootNextImg1,
      carBootNextImg2,
      carBootNextImg3,
      carBootNextImg4,
    ],
  },
  {
    id: 14,
    name: 'Garlend Setup',
    slug: 'garlend-setup',
    mainImage: garlendSetupMainImg,
    nextPageImages: [
      garlendSetupNextImg1,
      garlendSetupNextImg2,
      garlendSetupNextImg3,
      garlendSetupNextImg4,
    ],
  },
  {
    id: 15,
    name: 'Games & Activities',
    slug: 'games-activities',
    mainImage: gamesActivitiesMainImg,
    nextPageImages: [
      gamesActivitiesNextImg1,
      gamesActivitiesNextImg2,
      gamesActivitiesNextImg3,
      gamesActivitiesNextImg4,
    ],
  },
  {
    id: 16,
    name: 'Haldi',
    slug: 'haldi',
    mainImage: haldiMainImg,
    nextPageImages: [
      haldiNextImg1,
      haldiNextImg2,
      haldiNextImg3,
      haldiNextImg4,
    ],
  },
  {
    id: 17,
    name: 'Jungle Theme',
    slug: 'jungle-theme',
    mainImage: jungleThemeMainImg,
    nextPageImages: [
      jungleThemeNextImg1,
      jungleThemeNextImg2,
      jungleThemeNextImg3,
      jungleThemeNextImg4,
    ],
  },
  {
    id: 18,
    name: 'Bride Welcome',
    slug: 'bride-welcome',
    mainImage: brideWelcomeMainImg,
    nextPageImages: [
      brideWelcomeNextImg1,
      brideWelcomeNextImg2,
      brideWelcomeNextImg3,
      brideWelcomeNextImg4,
    ],
  },
];

// Helper function to get category by slug
export const getCategoryBySlug = (slug) => {
  return categoryImagesData.find(category => category.slug === slug);
};

// Helper function to get all images for a category (main + nextPageImages)
export const getCategoryImages = (slug) => {
  const category = getCategoryBySlug(slug);
  if (!category) return [];
  
  const allImages = [category.mainImage];
  if (category.nextPageImages && category.nextPageImages.length > 0) {
    allImages.push(...category.nextPageImages);
  }
  return allImages;
};
